import {
  requestType,
  failedType,
  succeedType,
  REQUIRE_OTP,
  VERIFY_OTP,
} from "./../actions/actionTypes";

const initState = {
  verifying_otp: false,
};

export const otpReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(VERIFY_OTP):
      return {
        ...state,
        verifying_otp: true,
      };
    case failedType(VERIFY_OTP):
      return {
        ...state,
        verifying_otp: false,
      };
    case succeedType(VERIFY_OTP):
      return {
        ...state,
        verifying_otp: false,
      };
    case REQUIRE_OTP:
    default:
      return {
        ...state,
      };
  }
};
